import { render, staticRenderFns } from "./create-distribute.vue?vue&type=template&id=1c0e225c"
import script from "./create-distribute.vue?vue&type=script&lang=js"
export * from "./create-distribute.vue?vue&type=script&lang=js"
import style0 from "./create-distribute.vue?vue&type=style&index=0&id=1c0e225c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports